import React from 'react';

const LoadingSkeleton = () => {
  return (
    <div className="min-h-screen bg-background pt-16">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 py-6 md:py-8 lg:py-12">
        <div className="mb-6 md:mb-8 lg:mb-12 animate-pulse">
          <div className="h-8 md:h-10 lg:h-12 bg-muted rounded w-64 md:w-80 mb-3" />
          <div className="h-4 md:h-5 bg-muted rounded w-96 md:w-[32rem]" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 mb-6 md:mb-8">
          {[1, 2, 3]?.map((i) => (
            <div key={i} className="bg-card rounded-lg p-4 md:p-6 shadow-sm border border-border animate-pulse">
              <div className="flex items-start justify-between mb-4">
                <div className="w-12 h-12 md:w-14 md:h-14 bg-muted rounded-lg" />
                <div className="w-16 h-6 bg-muted rounded-full" />
              </div>
              <div className="space-y-2">
                <div className="h-4 bg-muted rounded w-32" />
                <div className="h-8 md:h-10 bg-muted rounded w-24" />
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-4 gap-6 md:gap-8">
          <div className="lg:col-span-1 space-y-6">
            <div className="bg-card rounded-lg p-4 md:p-6 shadow-sm border border-border animate-pulse">
              <div className="h-6 bg-muted rounded w-32 mb-4" />
              <div className="space-y-3">
                {[1, 2]?.map((i) => (
                  <div key={i} className="flex items-start gap-3 p-3 rounded-lg bg-muted/50">
                    <div className="w-10 h-10 md:w-12 md:h-12 bg-muted rounded flex-shrink-0" />
                    <div className="flex-1 space-y-2">
                      <div className="h-4 bg-muted rounded w-24" />
                      <div className="h-3 bg-muted rounded w-full" />
                      <div className="h-5 bg-muted rounded w-16" />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="lg:col-span-3">
            <div className="bg-card rounded-lg p-4 md:p-6 lg:p-8 shadow-sm border border-border animate-pulse">
              <div className="flex items-center justify-between mb-4 md:mb-6">
                <div className="h-6 md:h-8 bg-muted rounded w-64" />
                <div className="w-20 h-6 bg-muted rounded-full" />
              </div>
              <div 
                className="grid gap-1.5 md:gap-2 lg:gap-2.5 mx-auto"
                style={{ gridTemplateColumns: 'repeat(10, minmax(0, 1fr))' }}
              >
                {Array.from({ length: 100 })?.map((_, i) => (
                  <div 
                    key={i}
                    className="bg-muted rounded"
                    style={{ aspectRatio: '1/1' }}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingSkeleton;